import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./socialMediaPage.css";
import twitter from "../../assets/icons/icons8-twitter.svg"
import youtube from "../../assets/icons/icons8-youtube.svg"
import facebook from "../../assets/icons/icons8-facebook.svg"
import instagram from "../../assets/icons/icons8-instagram.svg"
import tiktok from "../../assets/icons/icons8-tiktok.svg"
import linkedin from "../../assets/icons/icons8-linkedin.svg"

export const SocialMediaPage = () => {
  return (
    <>
      <div className="social-media-container mt-5 ml-5 text-uppercase">
        <h3>Social Media</h3>        
      </div>
      <div className="mt-5 mb-5">

      <img
            src={youtube}
            className="social-media-icons"
            alt="youtube logo"
      />

      <img
            src={instagram}
            className="social-media-icons"
            alt="instagram logo"
      />

     <img
            src={facebook}
            className="social-media-icons"
            alt="facebook logo"
      />

     <img
            src={twitter}
            className="social-media-icons"
            alt="twitter logo"
      />

     <img 
            src={tiktok}
            className="social-media-icons"
            alt="tiktok logo"
      />

      <img 
            src={linkedin}
            className="social-media-icons"
            alt="linkedin logo"
      />

      </div>
      <div className="social-media-list ml-5 mb-5">
        <p>Twitter: <a className="social-link-text" href="https://twitter.com/Lifetime">https://twitter.com/Lifetime</a></p>
        <p>Instagram: <a className="social-link-text" href="https://www.instagram.com/lifetimeproducts">https://www.instagram.com/lifetimeproducts</a></p>
        <p>Store Instagram: <a className="social-link-text" href="https://www.instagram.com/lifetime_store/">https://www.instagram.com/lifetime_store/</a></p>
        <p>Corp Facebook: <a className="social-link-text" href="https://www.facebook.com/lifetimeproducts">https://www.facebook.com/lifetimeproducts</a></p>
        <p>Store Facebook: <a className="social-link-text" href="https://www.facebook.com/lifetimestore">https://www.facebook.com/lifetimestore</a></p>
        <p>Assembly YouTube: <a className="social-link-text" href="https://www.youtube.com/@LifetimeProductsAssembly">https://www.youtube.com/@LifetimeProductsAssembly</a></p>
        <p>TikTok: <a className="social-link-text" href="https://tiktok.com/@lifetimeproducts?_t=8ZUaol1jfAp&_r=1">https://twitter.com/Lifetime</a></p>   
      </div>

    </>


  );
};


export default SocialMediaPage;
